export default "__VITE_ASSET__b3c9a38e__"